import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getTypologies = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit != null && `limit=${limit}`, offset != null && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/typologies?${queryParts.join("&")}`;
  const { data: typologies } = await axios.get(url);
  return typologies;
};

export const removeTypology = async (typologyId) => {
  const { data: removedTypology } = await axios.delete(`/typologies/${typologyId}`);
  return removedTypology;
};

export const addTypology = async (typology) => {
  const { data: addedTypology } = await axios.post(`/typologies`, {
    data: typology,
  });
  return addedTypology;
};

export const updateTypology = async ({ id, ...typologyData }) => {
  const { data: updatedTypology } = await axios.put(`/typologies/${id}`, {
    data: typologyData,
  });
  return updatedTypology;
};
